var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("header", { staticClass: "header-wrap" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", [
            _c("div", { staticClass: "fl" }, [
              _c(
                "a",
                {
                  staticClass: "logo cursor-pointer",
                  attrs: { href: "/aq/homePage" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/imgs/exhibition/logo.png"),
                      width: "170",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("time-zone"),
                _c("lang", { staticClass: "container-lang" }),
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _c(
                  "span",
                  {
                    staticClass: "notify",
                    on: {
                      click: function ($event) {
                        return _vm.jump("/aq/messageCenter")
                      },
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "iconfont-new",
                        staticStyle: { "margin-right": "5px" },
                      },
                      [_vm._v("")]
                    ),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("messageCenter.title")) +
                          " " +
                          _vm._s(
                            _vm.noReadMessageCount > 0
                              ? "(" + _vm.noReadMessageCount + ")"
                              : ""
                          )
                      ),
                    ]),
                    _vm.noReadMessageCount > 0
                      ? _c("span", { staticClass: "notification-dot" })
                      : _vm._e(),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "account",
                    on: {
                      mouseover: _vm.mouseoverFunc,
                      mouseout: _vm.mouseoutFunc,
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "iconfont-new",
                        staticStyle: { "margin-right": "5px" },
                      },
                      [_vm._v("")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "text",
                        on: {
                          click: function ($event) {
                            return _vm.jump("/aq/accountCenter")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("components.header.accountCenter"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm.showlist
                      ? _c(
                          "ul",
                          {
                            class: {
                              "down-list": true,
                              "en-width": _vm.locales === "en",
                            },
                          },
                          [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.jump("/aq/accountCenter")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "iconfont" }, [
                                  _vm._v(""),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("components.header.accountCenter")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.asyncMenuControl("M-0802")
                              ? _c("li", { on: { click: _vm.goKyc } }, [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "iconfont",
                                      staticStyle: { "font-size": "17px" },
                                    },
                                    [_vm._v("")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.header.identityVerification"
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.asyncMenuControl("M-13")
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.jump("/aq/offlineKyc")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "iconfont",
                                        staticStyle: { "font-size": "17px" },
                                      },
                                      [_vm._v("")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.header.identityVerification"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.asyncMenuControl("M-0803")
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.jump("/aq/cashAccount")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "iconfont",
                                        staticStyle: { "font-size": "16px" },
                                      },
                                      [_vm._v("")]
                                    ),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "components.header.withdrawCenter"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentsAccountRelated &&
                            _vm.asyncMenuControl("M-0807")
                              ? _c(
                                  "li",
                                  { on: { click: _vm.currentsLinkClick } },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "iconfont",
                                        staticStyle: { "font-size": "20px" },
                                      },
                                      [_vm._v("")]
                                    ),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "components.header.currentsCollection"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.asyncMenuControl("M-0805")
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.jump(
                                          "/aq/messageReceiverSetting"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "iconfont",
                                        staticStyle: { "font-size": "16px" },
                                      },
                                      [_vm._v("")]
                                    ),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("components.header.emailMsg")
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.vaAccountRelated
                              ? _c(
                                  "li",
                                  { on: { click: _vm.pingpongLinkClick } },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "iconfont",
                                        staticStyle: { "font-size": "20px" },
                                      },
                                      [_vm._v("")]
                                    ),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "components.header.pingpongCollection"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _c("li", { on: { click: _vm.logOut } }, [
                              _c("i", { staticClass: "iconfont" }, [
                                _vm._v(""),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("components.header.logOut")) +
                                  " "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "menu" },
            [
              _c(
                "el-menu",
                {
                  attrs: {
                    mode: "horizontal",
                    theme: "light",
                    "default-active": _vm.onRoutes,
                    "unique-opened": "",
                    router: "",
                  },
                },
                [
                  _c("el-menu-item", { attrs: { index: "/aq/homePage" } }, [
                    _vm._v(_vm._s(_vm.$t("components.header.homepage"))),
                  ]),
                  _vm.asyncMenuControl("M-02")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "1" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.isFromOmnichannel
                                  ? _vm.$t(
                                      "components.header.omniWebsiteManage"
                                    )
                                  : _vm.$t("components.header.websiteManage")
                              )
                            ),
                          ]),
                          _vm.asyncMenuControl("M-14")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/storeManage" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("components.header.storeManage")
                                      )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0202")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/websiteList" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isFromOmnichannel
                                          ? _vm.$t(
                                              "components.header.omniWebsiteManageReview"
                                            )
                                          : _vm.$t(
                                              "components.header.websiteManageReview"
                                            )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0201")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/groupManage" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isFromOmnichannel
                                          ? _vm.$t(
                                              "components.header.omniGroupManagement"
                                            )
                                          : _vm.$t(
                                              "components.header.groupManagement"
                                            )
                                      )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0203")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/storeOnboarding" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.storeOnboarding"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-10")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "9" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("components.header.transaction"))
                            ),
                          ]),
                          _vm.asyncMenuControl("M-1001")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/transitionLog" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.transitionLog")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-1002")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/refundLog" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.refundLog")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-03")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "2" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("components.header.fundManagement"))
                            ),
                          ]),
                          _vm.asyncMenuControl("M-0301")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/accountBalance" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.accountBalance")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0302")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/withdrawalDetail" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.withdrawalDetail"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0303")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/unsettledBalance" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.unsettledBalance"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-04")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "3" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("components.header.riskManagement"))
                            ),
                          ]),
                          _vm.asyncMenuControl("M-0401")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/chargeback" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.chargebackManagement"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0402")
                            ? _c(
                                "el-menu-item",
                                {
                                  attrs: {
                                    index: "/aq/riskTransactionManagement",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.riskTransactionManagement"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0403")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/blacklist" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.blacklist")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0404")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/whiteList" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.whitelist")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0407")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/disputeManage" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.disputeManage")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-09")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "5" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("components.header.paymentLink"))
                            ),
                          ]),
                          _vm.asyncMenuControl("M-0901")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/paymentLink" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.paymentLink")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.payLinkIsOldPage
                            ? [
                                _vm.asyncMenuControl("M-0902")
                                  ? _c(
                                      "el-menu-item",
                                      { attrs: { index: "/aq/brandList" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.header.brandList"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.asyncMenuControl("M-0903")
                                  ? _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: "/aq/paymentLinkTemplateList",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.header.templateManage"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _vm.asyncMenuControl("M-0905")
                                  ? _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: "/aq/paymentLinkThemeList",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.header.themeManage"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.asyncMenuControl("M-0906")
                                  ? _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: "/aq/paymentLinkModeList",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.header.modeManage"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-05")
                    ? _c(
                        "el-menu-item",
                        { attrs: { index: "/aq/logisticsManage" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("components.header.logisticsManage")
                              ) +
                              " "
                          ),
                          _vm.newIcon === "Y"
                            ? _c("span", { staticClass: "new-icon" }, [
                                _vm._v("New"),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-06")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "4" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("components.header.statement"))
                            ),
                          ]),
                          _vm.asyncMenuControl("M-0604")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/invoice" } },
                                [_vm._v("Invoice")]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0605")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/statementDownload" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.statementDownload"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0602")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/dataReport" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.header.transactionAnalysis"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.asyncMenuControl("M-07")
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "7" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(_vm._s(_vm.$t("components.header.system"))),
                          ]),
                          _vm.asyncMenuControl("M-0701")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/system" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.permission")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.asyncMenuControl("M-0702")
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "/aq/keySetting" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.header.keySetting")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }